/**
 * HorariosRendimiento — card showing daily meal windows and training schedule.
 *
 * All meal-window times are DRAFT defaults pending nutritionist sign-off.
 * Static structural card — no dynamic data, no dangerouslySetInnerHTML.
 * No native dialogs.
 */

// ---------------------------------------------------------------------------
// DRAFT meal-window defaults — pending nutritionist sign-off
// ---------------------------------------------------------------------------

/* DRAFT — pending nutritionist sign-off */
const MEAL_WINDOWS = [
  { time: "06:20 / 07:20", label: "Desayuno Energético", detail: "Avena, frutas, lácteos" },
  { time: "11:30 – 14:30", label: "Almuerzo Práctico", detail: "Bowls, viandas, legumbres" },
  { time: "16:00 – 17:30", label: "Merienda / Pre-Entreno", detail: "Frutas, yogur, barras" },
  { time: "20:00 – 21:30", label: "Cena Reparadora", detail: "Proteína magra, verduras" },
] as const;

/* DRAFT — pending nutritionist sign-off */
const STRATEGY_ROW = "Mar/Jue — Calidad + Recuperación";

// ---------------------------------------------------------------------------
// HorariosRendimiento
// ---------------------------------------------------------------------------

export function HorariosRendimiento(): JSX.Element {
  return (
    <div
      className="rounded-xl border border-zinc-700 bg-zinc-900 p-4"
      aria-label="Horarios y rendimiento"
    >
      <div className="mb-3">
        <h3 className="text-sm font-bold text-zinc-100">Horarios y Rendimiento</h3>
        <p className="text-xs text-zinc-500">Estructura diaria optimizada para tu rutina</p>
      </div>

      <ul className="flex flex-col gap-2" aria-label="Ventanas de comidas">
        {MEAL_WINDOWS.map(({ time, label, detail }) => (
          <li key={label} className="flex gap-3 text-sm">
            <span className="w-28 shrink-0 text-xs font-medium text-zinc-400">{time}</span>
            <div className="flex flex-col">
              <span className="font-medium text-zinc-200">{label}</span>
              <span className="text-xs text-zinc-500">{detail}</span>
            </div>
          </li>
        ))}
      </ul>

      {/* DRAFT strategy row — pending nutritionist sign-off */}
      <div className="mt-3 rounded-lg border border-zinc-800 bg-zinc-800/30 px-3 py-2">
        <span className="text-xs font-medium text-orange-400">{STRATEGY_ROW}</span>
      </div>
    </div>
  );
}
